import { PLATFORM } from '@/constants/platform'
import { FormattedOperator, Operator, OperatorWithUsersCount } from '@/types/operator'
import { Platform } from '@/types/platform'
import { DGEOperator } from '@/types/streams/operator'

export function formatOperators<T extends Platform>(
  platform: T,
  data: T extends typeof PLATFORM.DGE
    ? DGEOperator | DGEOperator[]
    : T extends typeof PLATFORM.DDE
      ? OperatorWithUsersCount[] | Operator[]
      : never
): FormattedOperator[] {
  switch (platform) {
    case PLATFORM.DGE: {
      const caseData = data as DGEOperator | DGEOperator[]
      const dataArray = Array.isArray(caseData) ? caseData : [caseData]
      return dataArray.map((o) => {
        const { mainContactEmail, createdAt, ...operator } = o
        return {
          email: mainContactEmail,
          usersCount: 0,
          createdDate: createdAt,
          ...operator
        }
      })
    }
    case PLATFORM.DDE: {
      const caseData = data as OperatorWithUsersCount[] | Operator[]
      return caseData.map((operator) => ({
        name: operator.name,
        email: operator.email,
        id: operator.id,
        createdDate: operator.createdDate,
        usersCount: 'usersCount' in operator ? operator.usersCount || 0 : 0
      }))
    }
    default:
      throw new Error('Unsupported platform')
  }
}
